import { fetchHeaders } from '../../utils/headers';
import Constants from '../../utils/constants';

export const reportingTourneesService = {
  exportCsv,
};

function exportCsv({ dateFrom, dateTo, client } = {}) {
  const base = Constants.API_ROUTE_REPORTING_TOURNEES_EXPORT;
  const params = new URLSearchParams();
  if (dateFrom) params.set('dateFrom', dateFrom);
  if (dateTo) params.set('dateTo', dateTo);
  if (client) params.set('client', String(client));
  const qs = params.toString();
  const url = qs ? `${base}?${qs}` : base;

  return fetch(url, fetchHeaders()).then((response) => {
    const contentDisposition = response.headers.get('Content-Disposition');
    let filename = 'reporting-tournees.csv';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match && match[1]) filename = match[1];
    }
    return response.blob().then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    });
  });
}
